import { useState, useCallback } from 'react';
import { apiClient } from '../../utils/api';
import { UserProfile, UserProfileResponse } from '../../types/user';

interface UseUserProfileReturn {
  profile: UserProfile | null;
  isLoading: boolean;
  error: string | null;
  fetchProfile: () => Promise<void>;
}

export const useUserProfile = (): UseUserProfileReturn => {
  const [profile, setProfile] = useState<UserProfile | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchProfile = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await apiClient.get<UserProfileResponse>('/api/v1/user/profile');
      
      if (response.data.status && response.data.data) {
        setProfile(response.data.data);
      } else {
        setError('프로필 정보를 가져오는데 실패했습니다.');
      }
    } catch (error) {
      console.error('프로필 조회 실패:', error);
      setError('프로필 정보를 가져오는데 실패했습니다.');
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    profile,
    isLoading,
    error,
    fetchProfile,
  };
};